import React, { useCallback, useMemo } from 'react';
import { TOOLTIP_POSITION } from 'taboola-ultimate-ui';
import { pxToRem } from 'taboola-ultimate-ui';
import { useNavigate } from 'hooks';
import { CampaignGroupTooltip } from '../components/CampaignGroupTooltip/CampaignGroupTooltip';
import { generateCampaignsGroupCreatorPath } from '../services/utils';
import styles from '../components/CampaignGroupTooltip/CampaignGroupTooltip.module.scss';

const tooltipStyle = {
    fill: styles.backgroundPrimaryBase,
    stroke: styles.borderSecondary,
    padding: '0',
    tailSize: pxToRem(12),
    insetSize: pxToRem(0),
    boxShadow: `0 ${pxToRem(2)} ${pxToRem(4)} rgba(0, 0, 0, 0.2)`,
};

const tailStyle = {
    transform: 'scale(1.5) rotate(45deg)',
    width: pxToRem(12),
    height: pxToRem(12),
    backgroundColor: styles.backgroundPrimaryBase,
    borderWidth: `0 1px ${pxToRem(1.5)} 1px`,
    marginRight: pxToRem(-6),
};
export const useCreateCampaignGroupTooltip = () => {
    const navigate = useNavigate();

    const handleCreateCampaignGroup = useCallback(() => {
        const creatorPath = generateCampaignsGroupCreatorPath();
        navigate(creatorPath);
    }, [navigate]);

    const tooltipProps = useMemo(
        () => ({
            onCreateGroup: handleCreateCampaignGroup,
        }),
        [handleCreateCampaignGroup]
    );

    const tooltipContent = useMemo(() => <CampaignGroupTooltip {...tooltipProps} />, [tooltipProps]);

    const tooltipOptions = useMemo(
        () => ({
            arrow: true,
            position: TOOLTIP_POSITION.LEFT,
            interactive: true,
            clickable: true,
            hoverable: false,
            offset: 15,
            offsetBody: 10,
            style: tooltipStyle,
            tailStyle,
            className: styles.tooltipContainer,
        }),
        []
    );

    return {
        tooltipContent,
        tooltipOptions,
    };
};
